<template>
  <el-dialog
    modal-class="card-dialog-wrap"
    v-model="state.dialogVisible"
    :title="$t('text.导出图片')"
    append-to-body
  >
    <div v-loading="state.loading">
      <el-progress
        v-if="linkImgNum"
        :text-inside="true"
        style="margin: 10px 0 10px 0"
        :stroke-width="26"
        :percentage="percentNum"
      />

      <div v-if="linkImgNum" class="tips-content">
        {{ $t("text.已保存") }}:
        <span class="add-img-nums">{{
          state.linkImgNum - state.linkImgList.length
        }}</span>
        {{ $t("unit.张") }}, {{ $t("text.成功") }}:
        <span class="add-img-nums">{{
          state.linkImgNum - state.linkImgList.length
        }}</span>
        {{ $t("unit.张") }}, {{ $t("text.失败") }}:
        <span class="add-img-nums">{{
          state.linkImgNum - state.linkImgList.length
        }}</span>
        {{ $t("unit.张") }}
      </div>
      <div class="form-box">
        <el-input
          v-model="state.linksTextarea"
          style="width: 100%"
          type="textarea"
          :rows="20"
          :placeholder="
            $t('placeholder.请输入图片链接，若要输入多个链接，请以回车换行')
          "
        />
        <el-checkbox
          v-model="state.asyncToZone"
          :label="$t('messages.同时保存图片到图片空间')"
          size="large"
        />
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button
          v-if="state.linkImgNum == 0 || !state.asyncToZone"
          type="primary"
          @click="onConfirmAddLink"
        >
          {{ $t("actions.添加") }}
        </el-button>
        <el-button @click="stopAddLink">{{ $t("actions.取消") }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import { CollectionTag, UploadFilled, Delete, Refresh, Picture, Download, Plus, ArrowDown, } from "@element-plus/icons-vue";
import OSS from "ali-oss";
import { useStore, mapGetters } from "vuex";
import type { Store } from "vuex";
import { getOssToken } from "@user-center/api/common";
import { defineComponent, computed, reactive, onBeforeMount, h, onMounted, watch } from "vue";
import type { ComputedRef } from "vue";
import moment from "moment";
import type { StoreStateType } from "@user-center/store/getters";
import type { UserStateType } from "@user-center/store/modules/user";
import lodash from "lodash-es";
import { useRoute } from "vue-router";
import type { RouteLocationNormalizedLoaded } from "vue-router";
import $ from "jquery";
import {
  ElMessageBox,
  ElMessage,
  ElButton,
  ElDropdown,
  ElNotification,
} from "element-plus";
import { $t } from "@user-center/utils/i18n.ts";

export default defineComponent({
  name: "UploadImageByLink",
  props: {
    selectedImgList: {
      type: Array,
      default: () => [],
    },
    allImgList: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  setup(props: any, ctx: any) {
    const state: UnwrapNestedRefs<any> = reactive({
      // 导出图片设置
      dialogVisible: false,
      linkImgList: [],
      linkImgFinish: false,
      linkImgNum: 0,
      linksTextarea: "",
      loading: false,
      asyncToZone: false,
    });
    let cosObject: OSS;
    let store: Store<StoreStateType> = useStore<StoreStateType>();
    let userinfo: any = computed(() => store.getters.userinfo);
    let percentNum: ComputedRef<any> = computed(() => {
      let num: any = 0;
      let numData: any =
        ((state.linkImgNum - state.linkImgList.length) / state.linkImgNum) *
        100;
      num = parseInt(numData);
      return isNaN(num) ? 0 : num;
    });
    function openDialog() {
      document.body.click();
      state.dialogVisible = true;
      state.linksTextarea = "";
      state.linkImgFinish = false;
      state.linkImgNum = 0;
      state.asyncToZone = false;
      state.linkImgList = [];
    }

    function stopAddLink() {
      state.dialogVisible = false;
      state.linksTextarea = "";
      state.linkImgFinish = false;
      state.linkImgNum = 0;
      state.asyncToZone = false;
      state.linkImgList = [];
    }
    function getBase64FromImageUrlBackEnd(url: string, cb: any) {
      let fetchImgUrl = url.replace(/http(s)?:/g, location.protocol);
      fetch(fetchImgUrl)
        .then((response: any) => response.blob())
        .then((blob: any) => {
          const reader: any = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const base64data: any = reader.result;
            let contentType: any = base64data.split(",")[0];
            cb(
              base64data.replace(/^data:image\/(.*);base64,/, ""),
              contentType
            );
          };
        });
    }
    function dataURItoBlob(contentType: string, base64Data: string): any {
      const byteCharacters = atob(base64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice: any = byteCharacters.slice(offset, offset + 512);

        const byteNumbers: any = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray: any = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
    let lastOssSign: any = null;
    function getOssTokenFn() {
      return new Promise((resolve, reject) => {
        if (lastOssSign && moment(lastOssSign.expiration).isAfter(moment())) {
          resolve(lastOssSign);
        } else {
          getOssToken()
            .then((sign: any) => {
              resolve(sign);
              lastOssSign = sign;
            })
            .catch((e: any) => {
              reject(e);
            });
        }
      });
    }
    function uploadFile(file: any, fileName: any): any {
      return new Promise((resolve, reject) => {
        getOssTokenFn()
          .then((sign: any) => {
            cosObject = new OSS({
              accessKeyId: sign.accessKeyId, // 后台的临时签名ID
              accessKeySecret: sign.accessKeySecret, // 后台的临时签名密钥
              stsToken: sign.securityToken,
              endpoint: sign.endpoint, // 后台配置的 OSS 节点
              bucket: sign.bucket, // 后台配置的 OSS 仓库名
            });

            const curTime = new Date();
            const year = curTime.getFullYear();
            const month = curTime.getMonth() + 1;
            const day = curTime.getDate();
            // 生成日期文件夹 自定义，可根据自身业务 区分文件夹。每个 ‘ / ’ 即是一级目录
            const dir =
              "images/userData/" +
              userinfo.value.id +
              "/" +
              year +
              "-" +
              (month < 10 ? "0" + month : month) +
              "-" +
              (day < 10 ? "0" + day : day) +
              "/";
            let uploadData = {
              key: "",
              name: "",
            };
            // 在文件名中追加时间戳，避免同名文件被覆盖
            const timestamp = Date.now();
            const originName = fileName || "";
            const dotIndex = originName.lastIndexOf(".");
            const hasExt = dotIndex !== -1;
            const baseName = hasExt ? originName.slice(0, dotIndex) : originName;
            const ext = hasExt ? originName.slice(dotIndex) : "";
            uploadData.name = `upload_${userinfo.value.id}_${baseName}_${timestamp}${ext}`;
            cosObject
              .put(dir + uploadData.name, file)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err: Error) => {
            if (err) {
              reject(err);
            }
          });
      });
    }
    function successAddCb(linkList: any) {
      state.loading = false;
      ctx.emit("add-link-images", linkList);
      stopAddLink();
    }

    function findBaseData(imgUrl: any, fileName: any): any {
      return new Promise((resolve, reject) => {
        var img: any = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        img.src = imgUrl;
        setTimeout(() => {}, 1000);
        img.onload = () => {
          console.log("onload," + imgUrl);
          let resData = "data:,";
          let canvas: any = document.createElement("canvas");
          let canvas2d: any = canvas.getContext("2d");
          canvas.height = img.height;
          canvas.width = img.width;
          canvas2d.drawImage(img, 0, 0);
          resData = canvas.toDataURL(`image/${fileName.split(".").pop()}`);
          canvas.remove();
          img.remove();
          resolve(resData);
        };
        img.onerror = function () {
          reject("图片加载错误");
          // 在这里处理加载失败的情况
        };
      });
    }

    function findBaseDataFn(img: any, fileName: any): any {
      return new Promise((resolve, reject) => {
        let timer: any = null;
        let total = 0;
        findBaseData(img, fileName).then((findData: any) => {
          if (findData == "data:,") {
            timer = setInterval(() => {
              findBaseData(img, fileName).then((findData: any) => {
                if (findData != "data:,") {
                  clearInterval(timer);
                  resolve(findData);
                } else if (total > 10) {
                  clearInterval(timer);
                  reject("查找不到base64数据");
                }
              });
            }, 500);
          } else {
            resolve(findData);
          }
        });
      });
    }
    async function onConfirmAddLink(): Promise<any> {
      state.loading = true;
      let linkList: any[] = state.linksTextarea
        .split(/[\n\s,，;]/)
        .filter((o: any) => !!o);
      if (!state.asyncToZone) {
        successAddCb(linkList);
      } else {
        state.linkImgNum = linkList.length;
        state.linkImgFinish = false;

        state.linkImgList = lodash.cloneDeep(linkList);
        for (let i = 0; i < state.linkImgList.length; i++) {
          let imgUrl: string = state.linkImgList[i];
          // 将图片URL转换为base64格式
          let fileName: any = imgUrl.split("/").pop();

          let reg = /^data:image\/(.*);base64,/;
          const regi = /\?.*/;
          let imgBase64Data: any = "";
          let unSetBase64 = true;
          try {
            imgBase64Data = await findBaseDataFn(imgUrl, fileName);
          } catch (e) {
            console.log(e);
          }

          let baseData: any = imgBase64Data.split(",").pop();
          let contentType: any = imgBase64Data.split(",")[0];
          if (imgBase64Data.length > 4e6) {
            getBase64FromImageUrlBackEnd(
              imgUrl,
              (baseData: any, contentType: any) => {
                uploadFile(dataURItoBlob(contentType, baseData), fileName).then(
                  (res: any) => {
                    console.log("uploadFile", res);
                    if (res.url) {
                      replaceOrgList(linkList, imgUrl, res);
                      if (state.linkImgList.length == 0) {
                        state.linkImgFinish = true;
                        successAddCb(linkList);
                      }
                    }
                  }
                );
              }
            );
          } else {
            uploadFile(dataURItoBlob(contentType, baseData), fileName).then(
              (res: any) => {
                console.log("uploadFile", res);
                if (res.url) {
                  replaceOrgList(linkList, imgUrl, res);
                  if (state.linkImgList.length == 0) {
                    state.linkImgFinish = true;
                    successAddCb(linkList);
                  }
                }
              }
            );
          }
        }
      }
    }

    function replaceOrgList(linkList: any, imgUrl: any, res: any) {
      lodash.remove(state.linkImgList, (url: any) => {
        return url == imgUrl;
      });
      let findIdx: any = lodash.findIndex(linkList, (url: any) => {
        return url == imgUrl;
      });
      linkList[findIdx] = res.url;
    }
    return {
      state,
      percentNum,

      openDialog,
      stopAddLink,
      onConfirmAddLink,
    };
  },
});
</script>
<style lang="scss" scoped>
.tips-content {
  margin: 0 0 10px;
}
.add-img-nums {
  color: red;
  font-size: 20px;
}
</style>
